import * as Sentry from '@sentry/browser';

/**
 * Register Sentry with the appropriate settings if the meta tag was found
 * @return void
 */
export function registerSentry () {
  const $sentryMeta = document.querySelector('meta[data-sentry-dsn]');

  if ($sentryMeta) {

    Sentry.init({
      dsn: $sentryMeta.dataset.sentryDsn,
      environment: $sentryMeta.dataset.env,
      release: $sentryMeta.dataset.release,
      whitelistUrls: [
        // only allow errors from the ufa.de domain to be detected
        /https:\/\/www\.ufa\.de/
      ]
    });
  }
}
